// Takes MINOR units (paise) and divides by 100 — the major-unit sibling is
// formatMajorUnits in user-summary-card-redesigned.tsx.
export function formatMinorUnits(currency: string, amountInPaise: number) {
  const amount = amountInPaise / 100;
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    // A malformed currency code throws RangeError; degrade to a plain line
    // rather than blanking the tooltip/tile.
    return `${currency || ""} ${Math.round(amount).toLocaleString("en-IN")}`.trim();
  }
}

export const REFUND_STATUS_LABELS: Record<string, string> = {
  REFUND_PENDING: "Pending",
  REFUND_PROCESSED: "Processed",
  REFUND_FAILED: "Failed",
};
